
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { NextSeo } from 'next-seo';
import { company } from '../../../components/config/Company';

const Refund = () => {
  return (
    <>
      <NextSeo
        title="Refund Policy | 247 Radio Carz"
        description="We want to ensure that all of our customers are fully satisfied with their experience with us, so we strive to provide timely and fair refunds when appropriate."
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/legal/policy/refund',
        }}
        canonical="https://www.247radiocarz.co.uk/legal/policy/refund"
      />
      <div className="font-sans ">
        {company.map((item) => (
          <>
            <h1 className="p-2 bg-gradient-to-r text-4xl tracking-tight from-primary to-secondary font-bold text-center text-slate-100">
              Refund Policy
            </h1>
            <div className="p-5">
              We understand that there may be times when our customers need a
              refund. We want to ensure that all of our customers are fully
              satisfied with their experience with us, so we strive to provide
              timely and fair refunds when appropriate.
              <br /> <br />
              To request a refund for your taxi rides, don't hesitate to contact
              us via email or phone within 14 days of taking your ride. When
              submitting a refund request, please provide the following
              information: <br />
              <ul className="py-3 px-10 list-disc">
                <li>
                  A detailed description of why you are requesting a refund.
                </li>
                <li>Your order/receipt number for the rides in question</li>
                <li>
                  Any relevant photos or videos necessary to support your claim
                  (if applicable)
                </li>
              </ul>
              We will review each refund request thoroughly and determine if a
              full or partial refund is appropriate. Please allow 3-5 business
              days for us to process your request. <br /> <br />
              If you have any questions about refunds, please do not hesitate to
              contact our customer service team. We look forward to helping you
              resolve the issue quickly and efficiently. <br /> <br /> However,
              some banks may take over seven working days to process and release
              the funds from a refund transaction. We, therefore, suggest
              contacting your bank directly if the “pending” amount has not been
              released after seven business days. Banks often have different
              processing times depending on the payment type used, and they can
              provide more detailed information on the specific transaction.{' '}
              <br /> <br /> Thank you for understanding, and we apologize for
              any inconvenience this may cause. We hope to continue providing
              you with the best service possible in the future. If you have any
              other questions or concerns, don't hesitate to contact us anytime.
            </div>
          </>
        ))}
      </div>
    </>
  );
};
export default Refund;
